import React from 'react';
import { Camera } from 'lucide-react';
import { galleryImages } from '../data/galleryData';

const GallerySection = ({ openImageModal }) => {
  return (
    <section id="gallery" className="py-32 bg-black/80 relative">
      <div className="max-w-7xl mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-24 animate-fade-in-up">
          <div className="mb-8">
            <Camera className="mx-auto text-red-600 opacity-80" size={48} />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-thin tracking-[0.2em] md:tracking-[0.3em] text-white mb-8 leading-tight">
            GALERÍA GASTRONÓMICA
          </h2>
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-red-600 to-transparent mx-auto mb-12"></div>
          <p className="text-lg text-gray-300 max-w-4xl mx-auto font-light leading-relaxed tracking-wide">
            Descubre nuestras creaciones culinarias y el arte en cada plato
          </p>
        </div>

        {/* Elegant Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 animate-fade-in-up" style={{animationDelay: '0.3s'}}>
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              onClick={() => openImageModal(index)}
              className="group relative overflow-hidden cursor-pointer"
            >
              <div className="aspect-square overflow-hidden luxury-shadow border border-red-900/30 transition-all duration-500 hover:border-red-600/50">
                <img 
                  src={image.src} 
                  alt={image.alt}
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:brightness-110"
                />
              </div>
              
              {/* Elegant Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500">
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-all duration-500">
                  <div className="text-xs font-light tracking-widest text-red-400 mb-2 uppercase">
                    {image.category}
                  </div>
                  <div className="text-sm font-light leading-tight mb-1 tracking-wide">
                    {image.alt.split(' - ')[0]}
                  </div>
                  {image.alt.split(' - ')[1] && (
                    <div className="text-xs text-gray-300 font-light leading-relaxed">
                      {image.alt.split(' - ')[1]}
                    </div>
                  )}
                </div>
              </div>
              
              {/* Click Indicator */}
              <div className="absolute top-6 right-6 bg-black/30 backdrop-blur-sm border border-red-600/50 rounded-full p-3 opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-red-600/20">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                </svg>
              </div>

              {/* Subtle glow effect on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-red-900/10 via-transparent to-red-800/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;